import classNames from 'classnames';
import Image from 'next/image';
import Typography from '@alltrails/core/components/Typography';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import styles from './UpsellFeatureList.module.scss';

export type UpsellFeatureVariant = 'default' | 'compact';

type Props = {
  feature: SubscriptionFeature;
  variant?: UpsellFeatureVariant;
};

// https://www.figma.com/design/vV97hwFyKhekbcMy2TuNyz/Feature-Merchandising?node-id=840-95326&t=XlR2wnwWYYfdIIZ3-4
export default function UpsellFeature({ feature, variant = 'default' }: Props) {
  const { headline, subheadline, thumbnailImage } = feature;
  const isCompact = variant === 'compact';
  const thumbnailSize = isCompact ? 72 : 84;

  return (
    <li className={styles.row}>
      <Image
        alt=""
        className={classNames(styles.thumbnail, { [styles.thumbnailCompact]: isCompact })}
        height={thumbnailSize}
        src={thumbnailImage}
        width={thumbnailSize}
      />
      <div className={styles.copy}>
        <Typography className={classNames(styles.rowTitle, { [styles.rowTitleCompact]: isCompact })} component="p" variant="text200bold">
          {headline}
        </Typography>
        <Typography className={styles.rowBody} color="secondary" component="p" variant={isCompact ? 'text100' : 'text150'}>
          {subheadline}
        </Typography>
      </div>
    </li>
  );
}
